import { render } from "./AhooraDane.vue?vue&type=template&id=3b9ec131"
import script from "./AhooraDane.vue?vue&type=script&lang=js"
export * from "./AhooraDane.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/clinicyas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__